import { ImageListItem, Box } from '@mui/material';
import Img from 'next/image';
import { FullGalleryProject } from './types';
import OptionalViewport from '../../../OptionalViewport';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';
import Titles from '../common/Titles';

type Props = {
  variant: 'standard' | 'masonry' | 'quilted';
  project: FullGalleryProject;
  wide: boolean;
  tall: boolean;
  onImageClick: () => void;
  isMobile: boolean;
  priority: boolean;
};

const PortfolioItem = ({
  project,
  wide,
  tall,
  onImageClick,
  isMobile,
  priority,
  variant,
}: Props) => {
  const image = project.image;
  const isQuilted = variant === 'quilted';
  const masonryProps =
    variant === 'masonry'
      ? {
          fill: false,
          width: image.meta.width,
          height: image.meta.height,
          style: {
            borderRadius: 'inherit',
            objectFit: 'cover' as const,
            width: '100%',
            height: 'auto',
            display: 'block',
          },
        }
      : {};
  return (
    <ImageListItem
      cols={isQuilted && wide ? 2 : 1}
      rows={isQuilted && tall ? 2 : 1}
      sx={{
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 0.5,
        '&:hover .overlay': {
          opacity: 1,
        },
      }}
      onClick={onImageClick}
    >
      <Img
        src={image.url}
        alt={image.altText || 'Gallery image'}
        loading={priority ? 'eager' : 'lazy'}
        priority={priority}
        fill
        sizes={isQuilted && (wide || tall) ? '50vw' : '25vw'}
        blurDataURL={image.blurDataUrl}
        placeholder={image.blurDataUrl ? 'blur' : 'empty'}
        style={{
          borderRadius: 'inherit',
          objectFit: 'cover',
        }}
        {...masonryProps}
      />
      <OptionalViewport viewport={'d'} initIsMobile={isMobile}>
        <DarkThemeProvider>
          <Box
            className="overlay"
            sx={{
              borderRadius: 'inherit',
              position: 'absolute',
              bottom: 0,
              left: 0,
              opacity: 0,
              display: 'flex',
              alignItems: 'end',
              justifyContent: 'start',
              width: '100%',
              transition: 'opacity 0.3s',
              background:
                'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0) 100%)',
              p: 2,
              pt: 12,
            }}
          >
            <Titles title={project.title} subtitle={project.subtitle} />
          </Box>
        </DarkThemeProvider>
      </OptionalViewport>
    </ImageListItem>
  );
};

export default PortfolioItem;
